<script>
  export default {
    props: {
      item: Object,
      relatorio: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        configuracao: this.$storage.configuracao()
      }
    },
    methods: {
    }
  }
</script>

<template>
    <div>
        <dl>
            <dt>Tipo de compra</dt>
            <dd>Livros</dd>
        </dl>

        <dl v-if="item.projetoMetaEtapa !== null">
            <dt>Meta etapa</dt>
            <dd>{{ `${item.projetoMetaEtapa.meta.nome} - ${item.projetoMetaEtapa.etapa.nome}` }}</dd>
        </dl>

        <div class="row" v-if="item.rubrica !== null">
            <dl class="col-xs-6">
                <dt>Rubrica</dt>
                <dd>{{ item.rubrica.nome }}</dd>
            </dl>

            <dl class="col-xs-6">
                <dt>Subrubrica</dt>
                <dd>{{ item.subrubrica.nome }}</dd>
            </dl>
        </div>

        <div class="row" v-if="item.idTipoProduto > 0">
            <dl class="col-xs-12">
                <dt>Tipo de produto</dt>
                <dd>{{ item.tipoProduto ? item.tipoProduto.nomeTipoProduto : "---" }}</dd>
            </dl>
        </div>

        <div class="row" v-if="item.idProduto > 0">
            <dl class="col-xs-12">
                <dt>Produto</dt>
                <dd>{{ item.produto ? item.produto.nome : "---" }}</dd>
            </dl>
        </div>

        <div class="row">
            <dl :class="[configuracao.utilizarValorEstimado ? 'col-xs-6' : 'col-xs-12']">
                <dt>Quantidade</dt>
                <dd>{{ item.quantidade | fixar2digitos('---') }}</dd>
            </dl>

            <dl class="col-xs-6" v-if="configuracao.utilizarValorEstimado">
                <dt>Valor estimado</dt>
                <dd>R$ {{ item.valorEstimado | fixar2digitos }}</dd>
            </dl>
        </div>

        <div class="row">
            <dl class="col-xs-6">
                <dt>Título</dt>
                <dd>{{ item.descricao }}</dd>
            </dl>
            <dl class="col-xs-6">
                <dt>ISBN</dt>
                <dd>{{ item.isbn || '---' }}</dd>
            </dl>
        </div>

        <div class="row">
            <dl class="col-xs-6">
                <dt>Autor</dt>
                <dd>{{ item.autor || '---' }}</dd>
            </dl>
            <dl class="col-xs-6">
                <dt>Editora</dt>
                <dd>{{ item.editora || '---' }}</dd>
            </dl>
        </div>

        <div class="row">
            <dl class="col-xs-4">
                <dt>Edição</dt>
                <dd>{{ item.edicao || '---' }}</dd>
            </dl>
            <dl class="col-xs-4">
                <dt>Volume</dt>
                <dd>{{ item.volume || '---' }}</dd>
            </dl>
            <dl class="col-xs-4">
                <dt>Exemplar</dt>
                <dd>{{ item.exemplar || '---' }}</dd>
            </dl>
        </div>

        <dl v-if="!configuracao.solCompraOcultarObservacoes">
            <dt>Observação do item de compra</dt>
            <dd class="white-space-pre">{{ item.observacaoItemCompra || '---' }}</dd>
        </dl>

        <dl>
            <dt>Objetivo/Justificativa da compra</dt>
            <dd class="white-space-pre">{{ item.objetivoCompra || '---' }}</dd>
        </dl>

        <dl>
            <dt>Local que o material será alocado</dt>
            <dd class="white-space-pre">{{ item.localAlocado || '---' }}</dd>
        </dl>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/compartilhado/FormListaLivros.vue